import Immutable from "immutable";
import keyConverter from "services/key-converter";

export class ResponsesPageRecord extends Immutable.Record({
  lastEditedResponseIndex: null,
  responseQueryFilter: "",
  responseSortingDirection: "last",
  responseSortingType: "created",
  responseNeedleLocations: Immutable.List([]), // To be deprecated
  expressionsToSave: Immutable.List([]),
  logBodyToTrain: "",
  isLoading: false,
  idOfLoadingAnswer: null,
  isVariablesLoading: true, // True by default in order to make it true before request is made
  selectedResponse: null,
  selectedMessageIdsInClipboard: Immutable.List(), // Selected messages for copying and pasting
  responseEditorActiveLanguages: Immutable.Map(),

  // The response flow data that we want to render in the sidebar
  responseFlowView: Immutable.Map(),

  // keep track of the last page we loaded to the page
  lastPageLoaded: 1,

  query: Immutable.Map({
    page: 1,
    filter: Immutable.Map({
      userinput: ""
    }),
    sort: Immutable.Map({
      sortBy: "created",
      sortDirection: "last"
    })
  })
}) {}

export const responsesPage = (state = new ResponsesPageRecord(), action) => {
  switch (action.type) {
    case "GET_ALL_VARIABLES_REQUEST":
      return state.set("isVariablesLoading", true);
    case "GET_ALL_VARIABLES_SUCCESS":
    case "GET_ALL_VARIABLES_FAILURE":
      return state.set("isVariablesLoading", false);

    case "CREATE_VARIABLE_REQUEST":
    case "UPDATE_VARIABLE_REQUEST":
    case "DELETE_VARIABLE_REQUEST":
      return state.merge({
        idOfLoadingAnswer: action.variable.originId
      });

    case "CREATE_RESPONSE_REQUEST":
    case "SAVE_RESPONSE_REQUEST":
      return state.merge({
        idOfLoadingAnswer: action.responseId || action.oldId
      });

    case "CREATE_RESPONSE_SUCCESS":
    case "CREATE_RESPONSE_FAILURE":
    case "SAVE_RESPONSE_SUCCESS":
    case "SAVE_RESPONSE_FAILURE":
    case "CREATE_VARIABLE_FAILURE":
    case "UPDATE_VARIABLE_FAILURE":
    case "DELETE_VARIABLE_SUCCESS":
      return state.merge({ idOfLoadingAnswer: null });
    case "DELETE_VARIABLE_FAILURE":
      return state.merge({ idOfLoadingAnswer: null });

    case "SET_RESPONSES_PAGE":
      return state.merge(action.payload);

    case "GET_RESPONSES_BY_ID_REQUEST":
    case "GET_RESPONSES_REQUEST":
    case "GET_RESPONSES_SHALLOW_REQUEST":
      return state.merge({ isLoading: true });

    case "GET_RESPONSES_BY_ID_SUCCESS":
    case "GET_RESPONSES_BY_ID_FAILURE":
    case "GET_RESPONSES_SUCCESS":
    case "GET_RESPONSES_SHALLOW_SUCCESS":
    case "GET_RESPONSES_FAILURE":
    case "GET_RESPONSES_SHALLOW_FAILURE":
      return state.merge({ isLoading: false });

    case "CREATE_RESPONSE":
      return state.merge({
        expressionsToSave: Immutable.List(action.expressions),
        logBodyToTrain: action.logBody
      });

    case "SET_ACTIVE_LANGUAGE":
      return state.updateIn(["responseEditorActiveLanguages"], map => (
        map.set(action.responseId, action.language)
      ));

    case "ADD_LANGUAGE_TO_RESPONSE_MESSAGES":
      return state.updateIn(["responseEditorActiveLanguages"], map => (
        map.set(action.responseId, action.language)
      ));

    case "GET_RESPONSE_QUICK_REPLIES_SUCCESS":
      return state.setIn(["responseFlowView", action.responseId], Immutable.fromJS(keyConverter(action.response.data.response.options)));

    default:
      return state;
  }
};
